import { createContext } from 'react'
import { getLanguageCode } from '../telegram/sdk'
import { ru } from './ru'
import { en } from './en'

export type Lang = 'ru' | 'en'
export type TKey = keyof typeof ru

export const DICTS: Record<Lang, Record<TKey, string>> = { ru, en }
export const LANG_STORAGE_KEY = 'brainhone.lang'

export function detectLang(): Lang {
  try {
    const saved = localStorage.getItem(LANG_STORAGE_KEY)
    if (saved === 'ru' || saved === 'en') return saved
  } catch {
    // недоступен
  }
  const code = getLanguageCode() ?? navigator.language
  return code.toLowerCase().startsWith('ru') ? 'ru' : 'en'
}

export function interpolate(template: string, params?: Record<string, string | number>): string {
  if (!params) return template
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = params[key]
    return value === undefined ? match : String(value)
  })
}

export interface I18nContextValue {
  lang: Lang
  setLang: (lang: Lang) => void
  t: (key: TKey, params?: Record<string, string | number>) => string
}

export const I18nContext = createContext<I18nContextValue | null>(null)
